"use strict";
/**
 * Terra Webhook & Data Model Types
 *
 * Webhook event schemas (Zod) — needed for runtime parsing of incoming webhooks.
 * Data model types — auto-generated from Terra's OpenAPI spec via openapi-typescript.
 *
 * To regenerate: pnpm --filter @see-stella/types generate:terra
 *
 * @see https://docs.tryterra.co/reference/data-models — Terra data models
 * @see https://github.com/tryterra/openapi — Terra OpenAPI spec
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TerraWebhookEventSchema = exports.TerraDataEventSchema = exports.TerraActivityEventSchema = exports.TerraBodyEventSchema = exports.TerraDailyEventSchema = exports.TerraSleepEventSchema = exports.TerraDeauthEventSchema = exports.TerraAuthEventSchema = exports.TerraUserSchema = void 0;
const zod_1 = require("zod");
// ============================================================================
// WEBHOOK EVENT SCHEMAS (Zod — needed for runtime parsing)
// ============================================================================
/** Terra user reference for webhook events. z.object is loose by default in Zod 4. */
exports.TerraUserSchema = zod_1.z.object({
    user_id: zod_1.z.string(),
    provider: zod_1.z.string(),
    reference_id: zod_1.z.string().nullable().optional(),
});
/** Sent when a user authenticates via widget or SDK */
exports.TerraAuthEventSchema = zod_1.z.object({
    type: zod_1.z.literal('auth'),
    user: exports.TerraUserSchema,
    status: zod_1.z.enum(['success', 'error']),
    reference_id: zod_1.z.string().nullable().optional(),
    widget_session_id: zod_1.z.string().nullable().optional(),
});
/** Sent when a user disconnects their provider */
exports.TerraDeauthEventSchema = zod_1.z.object({
    type: zod_1.z.literal('deauth'),
    user: exports.TerraUserSchema,
    status: zod_1.z.literal('success'),
});
// ============================================================================
// DATA EVENT SCHEMAS (Zod — for webhook type discrimination only)
// Data items are z.unknown() — cast to generated types after discrimination.
// ============================================================================
const TerraBaseDataEventFields = {
    user: exports.TerraUserSchema,
    data: zod_1.z.array(zod_1.z.unknown()),
};
exports.TerraSleepEventSchema = zod_1.z.object({
    type: zod_1.z.literal('sleep'),
    ...TerraBaseDataEventFields,
});
exports.TerraDailyEventSchema = zod_1.z.object({
    type: zod_1.z.literal('daily'),
    ...TerraBaseDataEventFields,
});
exports.TerraBodyEventSchema = zod_1.z.object({
    type: zod_1.z.literal('body'),
    ...TerraBaseDataEventFields,
});
exports.TerraActivityEventSchema = zod_1.z.object({
    type: zod_1.z.literal('activity'),
    ...TerraBaseDataEventFields,
});
/** Union data event — convenience type for any data webhook */
exports.TerraDataEventSchema = zod_1.z.object({
    type: zod_1.z.enum(['sleep', 'daily', 'body', 'activity']),
    user: exports.TerraUserSchema,
    data: zod_1.z.array(zod_1.z.unknown()),
});
// ============================================================================
// WEBHOOK EVENT (discriminated union of all event types)
// ============================================================================
exports.TerraWebhookEventSchema = zod_1.z.discriminatedUnion('type', [
    exports.TerraAuthEventSchema,
    exports.TerraDeauthEventSchema,
    exports.TerraSleepEventSchema,
    exports.TerraDailyEventSchema,
    exports.TerraBodyEventSchema,
    exports.TerraActivityEventSchema,
]);
//# sourceMappingURL=terra.js.map